import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import { backendURL } from 'src/constant/api/backendURL';

export interface ICategoriesState {
    data: Record<string, string[]>;
    rawData: any[];
    status: 'idle' | 'loading' | 'succeed' | 'failed';
    error: any;
}

const initialState: ICategoriesState = {
    data: {},
    rawData: [],
    status: 'idle',
    error: null,
};

export const fetchCategories = createAsyncThunk(
    'categories/getAllCategories',
    async (_, { rejectWithValue }) => {
        try {
            const { data } = await axios.get(`${backendURL}/category/getAll`);
            return data;
        } catch (error: any) {
            return rejectWithValue(error.message);
        }
    }
);

export const categoriesSlice = createSlice({
    name: 'categories',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchCategories.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchCategories.fulfilled, (state, { payload }) => {
                state.status = 'succeed';
                state.data = payload.formatted;
                state.rawData = payload.raw;
            })
            .addCase(fetchCategories.rejected, (state, { payload }) => {
                state.status = 'failed';
                state.error = payload;
            });
    },
});
